<template>
    <div class="list_nav_wrap nav_showcartype">
        <h1 class="list_nav_title clearfix">
            <label>{{ keyName }}</label>
        </h1>
        <ul click_type="sale-brands" class="clearfix findall">
            <li v-for="item in list">
                <a @click="doSelect(item.value)"
                    :class="{
                        'listNav_active': ~~active === item.value
                        }">{{ item.name }}</a>
            </li>
        </ul>
    </div>
</template>

<script>
    import urlUtil from '@souche-f2e/chunyan-util/url_util/url_util.js';
    const locationObj = urlUtil.initByLocation();
    export default {
        data() {
            return {
                key: 'showCarType',
                keyName: '车辆类型',
                active: locationObj.search.get('showCarType'),
                list: [{
                    value: 1,
                    name: '新车'
                }, {
                    value: 2,
                    name: '二手车'
                }]
            };
        },
        methods: {
            doSelect(value) {
                if (value) {
                    locationObj.s(this.key, value).s('index', null).go();
                } else {
                    locationObj.s(this.key, null).s('index', null).go();
                }
            }
        }
    };
</script>

<style lang="less" scoped>
    .nav_showcartype {
        border-bottom: 1px solid #e0e0e0;
        padding-bottom: 10px;
    }
    a {
        cursor: pointer;
    }
</style>

<style lang="less" scoped>
    a {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// NavShowCarType.vue?2e401270